module.exports = __webpack_public_path__ + "static/media/pagarazul.d95a8a4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pagarazul.png
// module id = 366
// module chunks = 0